import {
  NumberInput,
  TextField,
  TextInput,
  useRecordContext,
} from "react-admin";
import { JsonField } from "../ra-lb-tools/components/jsonField";
import { MyList } from "../ra-lb-tools/components/myList";
import { LockerField, LockerInput } from "../components/referenceFields";
import { TowerField, TowerInput } from "./tower/towers";
import { TowerTimezonedDateField } from "./tower/towerTimezonedDate";
import { PacketTypeField, PacketTypeInput } from "./enums/packet_types";
import { getValue } from "../ra-lb-tools/utils/tools";
import { LockerOpenReasonField } from "./enums/locker_open_reasons";
import { Row } from "../ra-lb-tools/components/row";
import { Column } from "../ra-lb-tools/components/column";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../ra-lb-tools/components/myReference";
import { LogLink } from "./towerHistory";

const BlinkErrorField = (props) => {
  return (
    <MyReferenceField
      reference="blink-error"
      primaryField="description"
      {...props}
    />
  );
};

const BlinkErrorInput = (props) => {
  return <MyReferenceInput reference="blink-error" {...props} />;
};

const EventDetail = () => {
  const record = useRecordContext();
  if (!record) return null;

  const packetType = getValue(record, "eventData.packet_type");
  switch (packetType) {
    case 26:
      return (
        <Row className="EventDetail" sx={{ alignItems: "baseline" }}>
          <span>Reason:</span>
          <LockerOpenReasonField
            source="eventData.locker_open_reason"
            style={{ marginLeft: "5px" }}
          />
        </Row>
      );

    default:
      break;
  }

  if (getValue(record, "eventData.error_code")) {
    return (
      <Row className="ErrorDetail" sx={{ alignItems: "baseline" }}>
        <span>Error:</span>
        <BlinkErrorField
          source="eventData.error_code"
          style={{ marginLeft: "5px" }}
        />
      </Row>
    );
  }

  return null;
};

export default function EventsList(props) {
  const filters = [
    <NumberInput source="id" alwaysOn key={1} />,
    <LockerInput source="lockerId" alwaysOn key={2} />,
    <TowerInput source="towerId" alwaysOn key={3} />,
    <PacketTypeInput source="packetType" alwaysOn key={4} />,
    <TextInput
      label="Client info"
      source="eventData.client_info"
      alwaysOn
      key={5}
    />,
    <BlinkErrorInput
      label="Error"
      source="eventData.error_code"
      alwaysOn
      key={6}
    />,
  ];

  const resource = "events";

  return (
    <MyList
      {...props}
      resource={resource}
      filters={filters}
      queryOptions={{
        meta: {
          transformResponse: (response) => ({
            ...response,
            _id: response.id,
            id: `${response.id}-${response.towerId}`,
          }),
        },
      }}
      sort={{
        field: "received",
        order: "DESC",
      }}
    >
      <TextField source="_id" label="Id" />
      <Column label="Packet type" className="PacketType">
        <PacketTypeField source="eventData.packet_type" />
        <EventDetail />
      </Column>
      <JsonField source="eventData" />
      <TowerTimezonedDateField
        label="Packet timestamp"
        source="eventData.packet_timestamp"
        showTime={true}
        sortable={false}
      />
      <TowerTimezonedDateField
        label="Received"
        source="received"
        showTime={true}
      />
      <TextField source="description" sortable={false} />
      <LockerField
        source="eventData.locker_id"
        label="Locker"
        sortable={false}
      />
      <TowerField source="towerId" />
      <LogLink source="Log" timestampSource="received" />
    </MyList>
  );
}
